import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SolarPage from "../pages/solar/page";
import BatteryPage from "../pages/battery/page";
import EVChargerPage from "../pages/ev-charger/page";
import ProjectsPage from "../pages/projects/page";
import ContactPage from "../pages/contact/page";
import SolarQuotePage from "../pages/solar-quote/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/solar",
    element: <SolarPage />,
  },
  {
    path: "/battery",
    element: <BatteryPage />,
  },
  {
    path: "/ev-charger",
    element: <EVChargerPage />,
  },
  {
    path: "/projects",
    element: <ProjectsPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/solar-quote",
    element: <SolarQuotePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
